module.exports = "/src/views/player/help/images/gun.png";